<template>
  <div>
    <a-layout-content :style="{ margin: '0px 0px 0' }">
      <div :style="{ background: '#fff', paddingTop: '8px',paddingLeft: '8px',paddingBottom: '2px' }">

        <a-form :form="form" @submit="getTableData">

          <template>
            <a-form-item style="margin:0px;">
              <a-select :style="{width: '400px'}"
                        @change="onTableSearchShopChange"
                        :placeholder="$t('message.views.productView.mainShop')"
                        v-decorator="['this', { rules: [{ required: true}] }]">
                <a-select-option v-for="shopSelectValue in tableShopSelectValues"
                                 :key="shopSelectValue.key+'-'+shopSelectValue.site">
                  {{'('+shopSelectValue.key+')'+shopSelectValue.name}}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-space direction="horizontal" align="start">
              <a-textarea :disabled="platformTitleDisabled" :placeholder="$t('message.views.productView.platformTitle')"
                          :auto-size="{ minRows: 1, maxRows: 1 }" id="platformTitle" allow-clear
                          :style="{width: '400px'}"
                          @change="onPlatformTitleChange"/>
              <a-input :disabled="platformSkuDisabled" :placeholder="$t('message.views.productView.platformSku')"
                       :auto-size="{ minRows: 1, maxRows: 3 }" id="platformSku" allow-clear
                       :style="{width: '300px'}"
                       @change="onPlatformSkuChange"/>

              <a-input :disabled="sellerSkuDisabled" :placeholder="$t('message.views.productView.sellerSku')"
                       id="sellerSku" allow-clear
                       :style="{width: '300px'}"
                       @change="onSellerSkuChange" :auto-size="{ minRows: 1, maxRows: 3 }"/>

              <a-button type="primary" html-type="submit">
                {{$t('message.views.productView.searchButton')}}
              </a-button>
            </a-space>
          </template>


        </a-form>
      </div>
    </a-layout-content>
    <a-table :columns=columns :data-source="data" :scroll="{ x: 1000 }"
             :style="{background: '#fff' }"
             :loading="mainTableLoading"
             @expand="onExpand" :pagination="pagination">
      <a-table
        slot="expandedRowRender"
        slot-scope="record"
        :columns="innerColumns"
        :data-source="innerData[record.itemId]"
        :pagination="false"
        :loading="subListLoading"
        :rowClassName="function(record, index){let className = 'twoe';if (index % 2 === 1) className = 'one';return className;}"
        size="small"
        :style="{background: '#ffffff' }">
        <template slot="innerImage" slot-scope="text, record">
          <a-popover trigger="hover">
            <template slot="content">
              <img :src="record.majorPictureUrl" style="width: 250px"/>
            </template>
            <img :src="record.majorPictureUrl" style="width: 50px"/>
          </a-popover>
        </template>
        <a slot="pdp" slot-scope="text,record" @click="pdpUrl(record.features.pdp)">{{record.groupUniCode}}</a>
        <template slot="skuStatus" slot-scope="text,record">
          <p style="margin: 1px; ">{{
            record.tenantId==117000?(record.skuStatus==1?'Normal':(record.skuStatus==-1?'DeleteBySeller':(record.skuStatus==-2?'DownShelf':(record.skuStatus==-3?'DownShelfByAdmin':(record.skuStatus==-4?'DeleteByAdmin':'UnKnown'))))):(record.tenantId==288000?(record.skuStatus==1?'Normal':(record.skuStatus==-1?'DeleteBySeller':(record.skuStatus==-2?'DownShelf':(record.skuStatus==-3?'DownShelfByAdmin':(record.skuStatus==-4?'DeleteByAdmin':'Unknown'))))):'Unknown')
            }}</p>
        </template>
        <template slot="scItem" slot-scope="text,record">
          <p style="margin: 1px; ">{{ record.features.fulfillmentSku }}</p>
          <p style="color: darkgrey;margin: 1px ">{{ record.features.targetItemId }}</p>
        </template>

<!--          <a @click="skuDetailRelation(record)">-->
<!--            <a-tooltip>-->
<!--              <template slot="title">-->
<!--                {{$t('message.views.productView.platformSkuDetail')}}-->
<!--              </template>-->
<!--              <a-icon type="file-search" style="fontSize:18px"/>-->
<!--            </a-tooltip>-->
<!--          </a>-->
<!--          &lt;!&ndash;        <a-popconfirm&ndash;&gt;-->
<!--          &lt;!&ndash;          v-if="data.length"&ndash;&gt;-->
<!--          &lt;!&ndash;          :title="$t('message.views.scItemView.sureDelete')"&ndash;&gt;-->
<!--          &lt;!&ndash;          @confirm="subDeleteRelation(record)"&ndash;&gt;-->
<!--          &lt;!&ndash;        >&ndash;&gt;-->
<!--          &lt;!&ndash;          <a-tooltip>&ndash;&gt;-->
<!--          &lt;!&ndash;            <template slot="title">&ndash;&gt;-->
<!--          &lt;!&ndash;              {{$t('message.views.productView.deleteRelatedPlatformSku')}}&ndash;&gt;-->
<!--          &lt;!&ndash;            </template>&ndash;&gt;-->
<!--          &lt;!&ndash;            <a-icon type="close-square" style="fontSize:18px;  color:dodgerblue"/>&ndash;&gt;-->
<!--          &lt;!&ndash;          </a-tooltip>&ndash;&gt;-->
<!--          &lt;!&ndash;        </a-popconfirm>&ndash;&gt;-->
        <template slot="Operation" slot-scope="text, record">
          <a @click="showItemRelationRecordDrawer(record.itemId, record.skuId)">
            <a-tooltip>
              <template slot="title">
                {{$t('message.views.productView.showRelation')}}
              </template>
              <a-icon type="eye" style="fontSize:18px"/>
            </a-tooltip>
          </a>
        </template>
      </a-table>
      <!--      <template slot="productImage" slot-scope="text, record">-->
      <!--        <a-popover trigger="hover">-->
      <!--          <template slot="content">-->
      <!--            <img :src="record.productImage" style="width: 250px"/>-->
      <!--          </template>-->
      <!--          <img :src="record.productImage" style="width: 50px"/>-->
      <!--        </a-popover>-->
      <!--      </template>-->
      <template slot="category" slot-scope="text,record">
        <p style="margin: 1px; ">{{ record.categoryName }}</p>
        <p style="color: darkgrey;margin: 1px ">{{ record.categoryId }}</p>
      </template>
      <template slot="brand" slot-scope="text,record">
        <p style="margin: 1px; ">{{ record.brandName }}</p>
        <p style="color: darkgrey;margin: 1px ">{{ record.brandId }}</p>
      </template>
      <template slot="itemStatus" slot-scope="text,record">
        <p style="margin: 1px; ">{{
          record.merchantCode=='LAZADA'?(record.itemStatus==1?'Normal':(record.itemStatus==-1?'DeleteBySeller':(record.itemStatus==-2?'DownShelf':(record.itemStatus==-3?'DownShelfByAdmin':(record.itemStatus==-4?'DeleteByAdmin':'UnKnown'))))):(record.merchantCode=='AEGDCHAIN'?(record.itemStatus==1?'Normal':(record.itemStatus==-1?'DeleteBySeller':(record.itemStatus==-2?'DownShelf':(record.itemStatus==-3?'DownShelfByAdmin':(record.itemStatus==-4?'DeleteByAdmin':'Unknown'))))):'Unknown')
          }}</p>
      </template>
      <template slot="shop" slot-scope="text,record">
        <p style="margin: 1px; ">{{ record.shopName }}</p>
        <p style="color: darkgrey;margin: 1px ">{{ record.sellerId }}</p>
      </template>

<!--      todo:编写-->


      <span slot="tag" slot-scope="text,record">
        <a-tag :color="record.merchantCode === 'LAZADA' ? '#7800ff' :  '#2db7f5'">
        {{ record.merchantCode }}
        </a-tag>
      </span>
<!--      <template slot="Detail" slot-scope="text, record">-->
<!--        <a @click="itemShowDrawer(record.scitemMerchantCode,record.sellerId,record.itemId)">-->
<!--          <a-tooltip>-->
<!--            <template slot="title">-->
<!--              {{$t('message.views.scItemView.fulfillmentSkuDetail')}}-->
<!--            </template>-->
<!--            <a-icon type="file-search" style="fontSize:18px"/>-->
<!--          </a-tooltip>-->
<!--        </a>-->
<!--        &lt;!&ndash;      <a v-show="record.scitemTenantId == 117000"&ndash;&gt;-->
<!--        &lt;!&ndash;         @click="showItemSearchDrawer(record.scitemMerchantCode,record.scitemTenantId,record.scItemId,record.cbShipperId,record.shipperId)">&ndash;&gt;-->
<!--        &lt;!&ndash;        <a-tooltip>&ndash;&gt;-->
<!--        &lt;!&ndash;          <template slot="title">&ndash;&gt;-->
<!--        &lt;!&ndash;            {{$t('message.views.scItemView.addRelatedPlatformSku')}}&ndash;&gt;-->
<!--        &lt;!&ndash;          </template>&ndash;&gt;-->
<!--        &lt;!&ndash;          <a-icon type="plus-square" style="fontSize:18px"/>&ndash;&gt;-->
<!--        &lt;!&ndash;        </a-tooltip>&ndash;&gt;-->
<!--        &lt;!&ndash;      </a>&ndash;&gt;-->

<!--      </template>-->
      <template slot="footer" slot-scope="currentPageData">

      </template>
    </a-table>
    <a-drawer width="1200" placement="right" :closable="true" :visible="itemRelationVisible"
              @close="onRelationRecordClose"
              style="font-weight: bold">
              <a-table
                :columns="relationColumns"
                :data-source="RelationRecordValues"
                :loading="relationRecordLoading"
                :pagination="RecordPagination"
                size="small"
                :style="{background: '#ffffff' }"
              >

<!--                <template slot="Status" slot-scope="text, record">-->
<!--                  <a-tooltip v-if = "RelationRecordValues.length && record.status !== 1">-->
<!--                    <template slot="title">-->
<!--                      {{$t('message.views.scItemView.deleteRelatedPlatformSku')}}-->
<!--                    </template>-->
<!--                    <a-icon type="close-square" style="fontSize:18px;  color:dodgerblue"/>-->
<!--                  </a-tooltip>-->
<!--                  <a-tooltip v-if = "RelationRecordValues.length && record.status === 1">-->
<!--                    <template slot="title">-->
<!--                      {{$t('message.views.scItemView.bindRelatedPlatformSku')}}-->
<!--                    </template>-->
<!--                    <a-icon type="plus-circle" style="fontSize:18px;  color:dodgerblue"/>-->
<!--                  </a-tooltip>-->
<!--                </template>-->
                  <template slot="Status" slot-scope="text, record">
                    <p v-if = "RelationRecordValues.length && record.status !== 1">
                        {{$t('message.views.scItemView.deleteRelatedPlatformSku')}}
                    </p>
                    <p v-if = "RelationRecordValues.length && record.status === 1">
                        {{$t('message.views.scItemView.bindRelatedPlatformSku')}}
                    </p>
                  </template>
              </a-table>
    </a-drawer>
  </div>
</template>

<script>

  import request from '../../utils/request'

  const itemSearchdata = []

  export default {

    watch: {
      'tableShopSelectValues': {
        deep: true,
        immediate: true,
        handler: function (newValue, oldValue) {
          this.tableShopSelectValues = newValue

          console.log('tableShopSelectValues newValue:' + newValue)
          console.log('tableShopSelectValues oldValue:' + oldValue)

        }
      },
    },
    computed: {
      columns () {
        return [

          {dataIndex: 'title', key: 'title', title: this.$t('message.views.productView.platformTitle'), width: 180},
          {dataIndex: 'itemId', key: 'itemId', title: this.$t('message.views.productView.itemId'), width: 100},
          {
            dataIndex: 'categoryId',
            key: 'categoryId',
            title: this.$t('message.views.productView.category'),
            width: 100,
            scopedSlots: {customRender: 'category'}
          },
          {
            dataIndex: 'brandId',
            key: 'brandId',
            title: this.$t('message.views.productView.brand'),
            width: 90,
            scopedSlots: {customRender: 'brand'}
          },
          {
            dataIndex: 'itemStatus',
            key: 'itemStatus',
            title: this.$t('message.views.productView.status'),
            width: 80,
            scopedSlots: {customRender: 'itemStatus'}
          },
          {
            dataIndex: 'sellerId',
            key: 'sellerId',
            title: this.$t('message.views.productView.mainShop'),
            width: 120,
            scopedSlots: {customRender: 'shop'}
          },
          // {dataIndex: 'tenantGroupId', key: 'tenantGroupId', title: this.$t('message.views.productView.itemSite'), width: 70},
          {
            dataIndex: 'merchantCode',
            key: 'merchantCode',
            title: this.$t('message.views.productView.merchant'),
            width: 70,
            scopedSlots: {customRender: 'tag'}
          },
          {
            title: this.$t('message.views.productView.operation'),
            dataIndex: '',
            key: 'x',
            scopedSlots: {customRender: 'Detail'},
            width: 100
          }
        ]
      },
      innerColumns () {
        return [
          {dataIndex: 'skuImage', key: 'skuImage', title: '', scopedSlots: {customRender: 'innerImage'}, width: 40},
          {
            dataIndex: 'groupUniCode',
            key: 'groupUniCode',
            title: this.$t('message.views.productView.platformSku'),
            width: 100,
            scopedSlots: {customRender: 'pdp'}
          },
          {
            dataIndex: 'sellerUniCode',
            key: 'sellerUniCode',
            title: this.$t('message.views.productView.sellerSku'),
            width: 100
          },
          {dataIndex: 'price', key: 'price', title: this.$t('message.views.productView.price'), width: 100},
          {dataIndex: 'skuStock', key: 'skuStock', title: this.$t('message.views.productView.skuStock'), width: 100},
          {
            dataIndex: 'skuStatus',
            key: 'skuStatus',
            title: this.$t('message.views.productView.skuStatus'),
            width: 100,
            scopedSlots: {customRender: 'skuStatus'}
          },
          {
            dataIndex: 'fulfillmentSku',
            key: 'fulfillmentSku',
            title: this.$t('message.views.productView.fulfillmentSku'),
            width: 100,
            scopedSlots: {customRender: 'scItem'}
          },
          {
            title: this.$t('message.views.productView.operation'),
            dataIndex: '',
            key: 'x',
            scopedSlots: {customRender: 'Operation'},
            width: 120
          }
        ]
      },
      relationColumns (){
        return [
          {
            dataIndex: 'scItemTitle',
            key: 'scItemTitle',
            title: this.$t('message.views.productView.fulfillmentTitle'),
            width: 180
          },
          {dataIndex: 'fulfillmentSku', key: 'fulfillmentSku', title: this.$t('message.views.productView.fulfillmentSku'), width: 100},
          {dataIndex: 'barcodes', key: 'barcodes', title: this.$t('message.views.productView.barcode'), width: 100},
          {
            dataIndex: 'shipperId',
            key: 'shipperId',
            title: this.$t('message.views.productView.mainShop'),
            width: 100,
            scopedSlots: {customRender: 'shop'}
          },
          {
            dataIndex: 'scitemMerchantCode',
            key: 'scitemMerchantCode',
            title: this.$t('message.views.productView.scItemMerchant'),
            width: 100,
            scopedSlots: {customRender: 'tag'}
          },
          {
            dataIndex: 'gmtModified',key: 'gmtModified', title: this.$t('message.views.productView.gmtModified'),width: 80
          },
          // {
          //   title: this.$t('message.views.productView.operation'),
          //   dataIndex: '',
          //   key: 'x',
          //   scopedSlots: {customRender: 'Detail'},
          //   width: 100
          // },
          {
            title: this.$t('message.views.productView.status'),
            dataIndex: '',
            key: 'x',
            scopedSlots: {customRender: 'Status'},
            width: 60
          }
        ]
      }
    },
    data () {
      return {
        platformSkuDisabled: false,
        sellerSkuDisabled: false,
        platformTitleDisabled: false,
        form: this.$form.createForm(this),
        data: null,
        platformTitle: null,
        platformSku: null,
        sellerSku: null,
        cbShipperId: null,
        tableSearchShop: null,
        tableShopSelectSite: null,
        watchValue: null,
        tableShopSelectValues: [],
        innerData: {},
        mainTableLoading: false,
        subListLoading: false,
        pagination: {
          defaultPageSize: 10,
          current: 1,
          pageSize: 10,
          total: 0,
          onChange: current => {
            this.pagination.current = current
            this.search()
          }
        },
        RecordPagination: {
          defaultPageSize: 10,
          current: 1,
          pageSize: 10,
          total: 0,
          onChange: current => {
            this.pagination.current = current
            this.showItemRelationRecordDrawer()
          }
        },
        itemRelationVisible:false,
        RelationRecordValues:[],
        RelationFocusScItemId:null,
        RelationRecordLoading:true,
      }
    },
    created () {
      request({
        url: '/shipper/shops',
        method: 'get'
      }).then(response => {
        var shops = response.data.data
        this.cbShipperId = shops[0].cbShipperId
        shops.forEach(n => {
          this.tableShopSelectValues.push({
            key: n.sellerId,
            name: n.shopName,
            site: n.tenantGroup
          })
        })
      })
    },

    methods: {
      skuDetailRelation (record) {

      },
      itemShowDrawer (merchantCode, sellerId, itemId) {

      },
      onRelationRecordClose(){
        this.itemRelationVisible = false
        this.RelationRecordValues = []
        this.RelationFocusScItemId = null
        this.paginationRelationRecord.current = 1
      },
      onExpand (e, record) {
        this.onList(record.itemId)
      },
      format(s) {
        const
          date = new Date(s),
          y = date.getFullYear(),
          m = date.getMonth() + 1,
          d = date.getDate(),
          hour = date.getHours(),
          minute = date.getMinutes(),
          second = date.getSeconds()
        return `${y}/${m < 10 ? '0'+m : m}/${d < 10 ? '0' + d : d}  ${hour < 10 ? '0'+hour : hour}:${minute < 10 ? '0' + minute : minute}:${second < 10?'0'+second : second}`
      },
      onPlatformSkuChange (e) {
        this.platformSku = e.target.value
        if (this.platformSku !== '' && this.platformSku !== null) {
          this.sellerSkuDisabled = true
          this.platformTitleDisabled = true
        } else {
          this.sellerSkuDisabled = false
          this.platformTitleDisabled = false
        }
      },
      onPlatformTitleChange (e) {
        this.platformTitle = e.target.value
        if (this.platformTitle !== '' && this.platformTitle !== null) {
          this.sellerSkuDisabled = true
          this.platformSkuDisabled = true
        } else {
          this.sellerSkuDisabled = false
          this.platformSkuDisabled = false
        }
      },
      onSellerSkuChange (e) {
        this.sellerSku = e.target.value
        if (this.sellerSku !== '' && this.sellerSku !== null) {
          this.platformSkuDisabled = true
          this.platformTitleDisabled = true
        } else {
          this.platformSkuDisabled = false
          this.platformTitleDisabled = false
        }
      },
      onTableSearchShopChange (e) {
        if (e == null || e == '') {
          this.tableSearchShop = null
          this.tableShopSelectSite = null
        } else {
          this.tableSearchShop = e.split('-')[0]
          this.tableShopSelectSite = e.split('-')[1]
        }
      },

      showItemRelationRecordDrawer (itemId, skuId) {
        this.RelationRecordLoading = true
        request({
          url: '/item/getRecord/',
          method: 'post',
          data: {
            itemId : itemId,
            skuId : skuId,
            pageIndex : this.RecordPagination.current,
            pageSize : this.RecordPagination.pageSize
          }
        }).catch(error => {
          console.log('exception:' + JSON.stringify(error))
          this.RelationRecordLoading = false
        }).then(response => {
          this.RelationRecordValues = response.data.result
          for(let index = 0; index < this.RelationRecordValues.length; index++){
            this.RelationRecordValues[index].gmtModified = this.format(this.RelationRecordValues[index].gmtModified)
          }
          this.RecordPagination.total = parseInt(response.data.total)
          this.RelationRecordLoading = false
          this.itemRelationVisible = true
        })
      },
      search () {
        if (this.tableSearchShop == null || this.tableSearchShop == '') {
          this.warningAlert('shop is necessary')
        }
        if (this.tableShopSelectSite == null || this.tableShopSelectSite == '') {
          this.warningAlert('shop site is necessary')
        }
        this.mainTableLoading = true
        request({
          url: '/item/search/' + this.tableShopSelectSite,
          method: 'post',
          data: {
            sellerId: this.tableSearchShop,
            pageIndex: this.pagination.current,
            pageSize: this.pagination.pageSize,
            outerId: this.sellerSku,
            innerId: this.platformSku,
            title: this.platformTitle
          }
        }).catch(error => {
          console.log('exception:' + JSON.stringify(error))
          this.mainTableLoading = false
        }).then(response => {
          this.data = response.data.result
          const pagination = {...this.pagination}
          pagination.total = parseInt(response.data.total)
          this.pagination = pagination
          this.mainTableLoading = false
        })

      },
      getTableData (e) {
        e.preventDefault()
        this.form.validateFields((err, values) => {
          console.log('err:${} values:${}', JSON.stringify(err), JSON.stringify(values))
          if (!err) {
            this.search()
          }
        })
      },
      onList (itemId) {
        this.subListLoading = true
        this.innerData[itemId] = null
        request({
          url: '/item/listSkus/' + this.tableShopSelectSite + '/' + this.tableSearchShop + '/' + itemId,
          method: 'get'
        }).catch(exception => {
          this.subListLoading = false
        }).then(response => {
          this.innerData[itemId] = response.data.data
          console.log(JSON.stringify(this.innerData))
          const pagination = {...this.pagination}
          this.pagination = pagination
          this.subListLoading = false
        })
      },
      pdpUrl (pdp) {
        window.open(pdp)
      },
      successAlert (msg) {
        this.$message.success(msg)
      },
      errorAlert (msg) {
        this.$message.error(msg)
      },
      warningAlert (msg) {
        this.$message.warning(msg)
      },
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/Item/ProductView.vue